import axios from 'axios';

export default {
  state: {
    push: {},
    loading: false,
    error: null,
    pushLoaded: false,
    pushLoading: false
  },
  mutations: {
    SET_PUSH(state, push) {
      state.push = push.data;
      state.pushLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PUSH_LOADING(state, status) {
      state.pushLoading = status;
    },
    SET_PUSH_ERROR(state, error) {
      state.pushError = error;
    },
    UNSET_PUSH(state) {
      state.pushLoaded = false;
      state.pushLoading = false;
      state.push = [];
    },
  },
  actions: {
    async fetchPush({ commit, state }) {
      commit('UNSET_PUSH');
      try {
        commit('SET_PUSH_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/push/');
        commit('SET_PUSH', response.data);
        commit('SET_PUSH_ERROR', null);
      } catch (error) {
        commit('SET_PUSH_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching push:', error);
      } finally {
        commit('SET_PUSH_LOADING', false);
      }
    },
    async readPush({ commit, state }, data) {
      let id = data['id']?data['id']:0
      const response = await axios.post('api/push/'+id+'/', {data: data}, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
  },
  getters: {
    push: state => state.push,
    pushLoading: state => state.pushLoading,
    pushError: state => state.pushError,
    pushLoaded: state => state.pushLoaded
  }
}